import { Checkbox } from "@chakra-ui/react";
import { gql } from "__generated__/gql";
import useAsyncCompleteToast from "components/Shared/useAsyncCompleteToast";
import { useBrandMutation } from "utils/apollo/hooks/brand";

const assignMutation = gql(/* GraphQL */ `
  mutation ProductAttributesMatrixAttributeAssignmentCheckboxCreateSkuProductAttribute(
    $skuId: UUID!
    $productAttributeId: UUID!
  ) {
    createSkuProductAttribute(
      input: {
        skuProductAttribute: {
          skuId: $skuId
          productAttributeId: $productAttributeId
        }
      }
    ) {
      sku {
        id
        ...ProductAttributesMatrixSkuProductAttributeIds
      }
    }
  }
`);

const unassignMutation = gql(/* GraphQL */ `
  mutation ProductAttributesMatrixAttributeAssignmentCheckboxDeleteSkuProductAttribute(
    $skuId: UUID!
    $productAttributeId: UUID!
  ) {
    deleteSkuProductAttributeBySkuIdAndProductAttributeId(
      input: { skuId: $skuId, productAttributeId: $productAttributeId }
    ) {
      sku {
        id
        ...ProductAttributesMatrixSkuProductAttributeIds
      }
    }
  }
`);

type Props = {
  attributeId: UUID;
  isAssigned: boolean;
  isDisabled?: boolean;
  skuId: UUID;
};

export default function ProductAttributesMatrixAttributeAssignmentCheckbox({
  attributeId,
  isAssigned,
  isDisabled,
  skuId,
}: Props) {
  const { showErrorToast } = useAsyncCompleteToast();
  const [createSkuProductAttribute, { loading: isAssigning }] =
    useBrandMutation(assignMutation);
  const [deleteSkuProductAttribute, { loading: isUnassigning }] =
    useBrandMutation(unassignMutation);

  const handleChange = async (isAssignedNext: boolean) => {
    if (isAssignedNext === isAssigned) return;

    const variables = { skuId, productAttributeId: attributeId };

    const mutate = isAssignedNext
      ? createSkuProductAttribute({ variables })
      : deleteSkuProductAttribute({ variables });

    await mutate.catch((error: unknown) => {
      showErrorToast(error, {
        title: "Could not update product attribute assignment",
      });
      throw error;
    });
  };

  return (
    <Checkbox
      isChecked={isAssigned}
      isDisabled={Boolean(isDisabled) || isAssigning || isUnassigning}
      onChange={(evt) => {
        void handleChange(evt.target.checked);
      }}
    />
  );
}
